import { SortDirection } from "generated/graphql";

export const sortDirectionMap = {
  asc: SortDirection.ASC,
  desc: SortDirection.DESC,
  ASC: SortDirection.ASC,
  DESC: SortDirection.DESC,
};
